import React, { useEffect, useRef, useState } from "react";
import CommonModalView from "presentational/common/modals/CommonModalView";
import UserUnitView from "presentational/common/userUnit/UserUnitView";
import ClearAdornmentButtonView from "presentational/common/ClearAdornmentButtonView";
import CommonTextField from "presentational/common/CommonTextField";
import TXT from "presentational/common/multinational/TXT";
import { isValidInput } from "lib/textFilter";
import { useHistory } from "react-router-dom";
import Restful from "lib/restful";
import { withStore } from "store/storeHandler";
import config from "lib/fr-config";
import { getFilteredInput } from "lib/textFilter";
import { withStyles } from "@material-ui/core/styles";
import { withToken } from "lib/forceTokenRenewComponent";
import FullScreenLoadingView from "presentational/common/FullScreenLoadingView";
import Typography from "@material-ui/core/Typography";
import { getEssentialUrl } from "lib/urlQueryParser";
import PropTypes from "prop-types";

const colorCss = config.css.color;

const CustomTypography = withStyles({
  colorSecondary: { color: colorCss.colorOfDanger }
})(Typography);

UsernameSelectorModalView.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired
};

UsernameSelectorModalView.defaultProps = {
  writeNewTagMode: false
};

function UsernameSelectorModalView(props) {
  const { open, onClose, disabled } = props;
  const { getIdTokenWT } = props;
  const { AppErrorActions } = props;
  const [mode, setMode] = useState("input");
  const [username, setUsername] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [autoComplete, setAutoComplete] = useState({});

  const history = useHistory();

  const inputField = useRef();

  useEffect(() => {
    if (disabled && open) closeModal();
  }, [disabled, open]);
  useEffect(() => {
    if (open) {
      setAutoComplete({});
      setMode("input");
      setUsername("");
    }
  }, [open]);

  const getFilteredUsername = () => {
    if (!username || username === "") {
      return null;
    }

    const filteredUsername = getFilteredInput("username", username);
    if (!isValidInput("username", filteredUsername)) {
      return null;
    } else {
      return filteredUsername;
    }
  };

  const getAutoComplete = async username => {
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;

    const { code, res, errInfo } = await Restful.getAutocompleteUsernameListAPI(
      { username, idToken }
    );
    if (code === "error") {
      const errObj = Error("api error");
      errObj.errorValue = { ...errInfo };
      throw errObj;
    }
    return res;
  };

  const getBtnListElement = () => {
    if (!autoComplete) {
      console.log("error");
      console.error("error");
    }
    const { list } = autoComplete;
    const hasList = autoComplete && list && list.length > 0;
    const nullList = (
      <CustomTypography>
        <TXT name="msg_userDoesntExist" />
      </CustomTypography>
    );
    const majorBrandList =
      list &&
      list.map(unit => (
        <UserUnitView
          key={unit.username}
          name={unit.username}
          image={unit.image}
          location={unit.location}
          gender={unit.gender}
          onClick={handleRecommendBtnClick(unit.username)}
        />
      ));
    return <div>{hasList ? majorBrandList : nullList}</div>;
  };

  const closeModal = () => {
    onClose();
  };

  const handleKeyPress = e => {
    if (e.key === "Enter") {
      handleNextClick();
      e.preventDefault();
    }
  };

  const handleChange = e => {
    const { value } = e.target;
    setUsername(value);
  };

  const handleNextClick = async () => {
    const filteredUsername = getFilteredUsername();

    if (!filteredUsername || filteredUsername === "") return null;

    if (isLoading) return null;
    setIsLoading(true);

    let autoComplete;
    try {
      autoComplete = await getAutoComplete(filteredUsername);
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
      return null;
    }

    setIsLoading(false);

    setAutoComplete(autoComplete);
    const { list } = autoComplete;
    if (list.length === 1 && list[0].username === filteredUsername) {
      handleRecommendBtnClick(list[0].username)();
    } else {
      setMode("select");
    }
  };

  const handleBackClick = () => {
    setMode("input");
  };

  const handleRecommendBtnClick = value => () => {
    history.push(getEssentialUrl({ type: "portfolio" })(value));
    closeModal();
  };

  const handleReset = () => {
    setUsername("");
    inputField.current.focus();
  };

  const handleClose = () => {
    closeModal();
  };

  const render = () => {
    const fstBtnText =
      mode === "input" ? (
        <TXT name="btnModal_cancel" />
      ) : (
        <TXT name="btnModal_back" />
      );
    const fstBtnFunc = mode === "input" ? handleClose : handleBackClick;
    const secBtnText = mode === "input" ? <TXT name="btnModal_next" /> : null;
    const secBtnFunc = mode === "input" ? handleNextClick : null;
    const inputGuideText = <TXT name="msg_helperUsername" />;

    return (
      <CommonModalView
        open={open}
        onClose={handleClose}
        paperStyle={{ width: "100%" }}
        titleText={<TXT name="titleModal_findUsers" />}
        contentComponent={
          <div>
            {mode === "input" && (
              <div>
                <CommonTextField
                  inputRef={inputField}
                  autoFocus
                  value={username}
                  onKeyDown={handleKeyPress}
                  onChange={handleChange}
                  margin="normal"
                  helperText={getFilteredUsername() || inputGuideText}
                  InputProps={{
                    endAdornment: (
                      <ClearAdornmentButtonView onClick={handleReset} />
                    )
                  }}
                />
                {isLoading && <FullScreenLoadingView />}
              </div>
            )}
            {mode === "select" && getBtnListElement()}
          </div>
        }
        firstButtonText={fstBtnText}
        firstButtonFunc={fstBtnFunc}
        secondButtonText={secBtnText}
        secondButtonFunc={secBtnFunc}
        secondButtonDisabled={
          mode === "input" && (!getFilteredUsername() || isLoading)
        }
      />
    );
  };

  return render();
}

export default withToken(
  withStore({
    dispatchMap: ["appError"]
  })(UsernameSelectorModalView)
);
